import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: () => import('../views/Home.vue')
    },
    {
      path: '/about',
      component: () => import('../views/About.vue')
    },
    {
      path: '/download',
      component: () => import('../views/Download.vue')
    },
    {
      path: '/contact',
      component: () => import('../views/Contact.vue')
    }
  ]
})

export default router 